import React from 'react';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import service from '../../../api/services';

interface Product {
  id: number;
  name: string;
};
type FilterOptionType = {
  id:string;
  [key: string]: string | number
}
type AttributeGroup = Record<string, FilterOptionType[]>
type FilterType = Record<string, AttributeGroup>

export interface CheckboxState {
  products: FilterType;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: CheckboxState = {
  products: {},
  status: 'idle',
  error: null,
};

const removeDuplicateBrand = (data: FilterType): FilterType => {
  const result: FilterType = {};

  for (const groupKey in data) {
    result[groupKey] = {};

    for (const attributeKey in data[groupKey]) {
      const options = data[groupKey][attributeKey];

      if (attributeKey === 'brand') {
        const seen = new Set<string>();
        result[groupKey][attributeKey] = options.filter(option => {
          const brandName = option.brand_name;
          if (brandName && !seen.has(brandName as string)) {
            seen.add(brandName as string);
            return true;
          }
          return !brandName; // keep items without brand_name
        });
      } else {
        result[groupKey][attributeKey] = options;
      }
    }
  }

  return result;
};

// Async thunk to fetch product list from an API
export const fetchFilterList = createAsyncThunk< FilterType, void,  { rejectValue: string } >(
  'filterList/fetchFilterList',
  async (_, { rejectWithValue }) => {
    try {
      const response = await service.Product.filter();
      if (response.status === 200) {
        let modifiedData:FilterType = removeDuplicateBrand(response?.data?.data)
        return modifiedData
        // return response.data.data;
      } else {
        return rejectWithValue('Failed to fetch filter list');
      }
    } catch (error:any) {
      return rejectWithValue(error.message);
    }
  }
);

const filterListSlice = createSlice({
  name: 'productList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFilterList.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchFilterList.fulfilled, (state, action: PayloadAction<FilterType>) => {
        state.status = 'succeeded';
        state.products = action.payload;
      })
      .addCase(fetchFilterList.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch products';
      });
  },
});

export default filterListSlice.reducer;
